<template>
  <div class="container-fluid">
    <breadcrumbs></breadcrumbs>
    <router-view></router-view>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title pb-3">Tickets</h3>
            <div v-if="showSpinner" class="spinner-wrap">
              <spinner />
            </div>
            <grid
              v-else
              hideSearch
              fieldName="tickets"
              :columns="columns"
              :value="tickets"
              :limit="limit"
              :page="page"
              :meta="meta"
              @limit="changeLimit"
              @page="changePage"
            >
              <span slot="id" slot-scope="props">
                <router-link @click.stop :to="{ name: 'Messages', params: { ticketId: props.row.id } }">
                  {{ props.row.id | last(4) }}
                </router-link>
              </span>
              <span slot="assignedAt" slot-scope="props">
                <span v-if="props.row.assignedAt">
                  {{props.row.assignedAt - props.row.createdAt | seconds}}
                </span>
                <span v-else>
                  Not assigned
                </span>
              </span>
              <span slot="messages.length" slot-scope="props">
                {{props.row.messages ? props.row.messages.length : 0}}
              </span>
              <span slot="representativeName" slot-scope="props">
                {{props.row.representativeName || 'Anonym'}}
              </span>
              <span slot="updatesByVisitor" slot-scope="props">
                <span v-if="props.row.updatesByVisitor && props.row.updatesByVisitor.closedByVisitorAt">
                  {{props.row.updatesByVisitor.closedByVisitorAt - props.row.createdAt | seconds}}
                </span>
                <span v-else>Not closed</span>
              </span>
              <span slot="createdAt" slot-scope="props">
                {{props.row.createdAt | date}}
              </span>
            </grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Grid from '@/components/Grid';
import Spinner from '@/components/Spinner';
import { db } from '@/helpers/firebase';

const COLUMNS = [
  { field: 'id', title: 'ID' },
  { field: 'createdAt', title: 'Created' },
  { field: 'searchText', title: 'Input' },
  { field: 'metadata.campaignName', title: 'Campaign' },
  { field: 'representativeName', title: 'Agent' },
  { field: 'info.deviceType', title: 'Device' },
  { field: 'messages.length', title: 'Msg(s)' },
  { field: 'assignedAt', title: 'Taken (sec)' },
  { field: 'updatesByVisitor', title: 'Left (sec)' },
];

export default {
  components: { Spinner, Grid },
  created() {
    this.ref = db.child('tickets').orderByChild('createdAt');
    this.fetchData();
  },
  destroyed() {
    this.ref.off('value');
  },
  computed: {
    columns: () => COLUMNS,
  },
  data() {
    return {
      tickets: [],
      limit: 10,
      page: 0,
      showSpinner: false,
      meta: { count: 0 },
    };
  },
  methods: {
    fetchData() {
      this.showSpinner = true;
      this.ref.off('value');
      this.ref.on('value', sagment => {
        const value = sagment.val() || {};
        const offset = this.page * this.limit;
        const tickets = Object.keys(value)
          .map(id => ({
            ...value[id],
            messages: Object.values(value[id].messages || {}),
            id,
          }))
          .sort((a, b) => b.createdAt - a.createdAt);
        this.meta = { count: tickets.length };
        this.tickets = tickets.slice(offset, offset + this.limit);
        this.showSpinner = false;
      });
    },
    openMessages(row) {
      this.$router.push({ name: 'Messages', params: { ticketId: row.id } });
    },
    changeLimit(event) {
      this.limit = +event.target.value;
      this.fetchData();
    },
    changePage(page) {
      this.page = page;
      this.fetchData();
    },
    setFirstPage() {
      this.page = 0;
      this.fetchData();
    },
  },
  filters: {
    last: (str, count) => str.slice(-count),
    seconds: number => (number / 1000).toFixed(0),
  },
};
</script>
<stlye scoped></stlye>



// WEBPACK FOOTER //
// src/pages/Tickets/Tickets.vue